module.exports = __webpack_public_path__ + "img/boda-ceremonia-thumbnail.25da480d.jpg";